import { render, staticRenderFns } from "./InsightsView.vue?vue&type=template&id=c3885ac8&scoped=true"
import script from "./InsightsView.vue?vue&type=script&lang=js"
export * from "./InsightsView.vue?vue&type=script&lang=js"
import style0 from "./InsightsView.vue?vue&type=style&index=0&id=c3885ac8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3885ac8",
  null
  
)

export default component.exports